export default __webpack_public_path__ + "static/media/8.e20b75d2.jpg";